import { formatURIComponent } from './utils'

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=design&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '华美服务 = 咨询服务 + 华美云 + 尽管问',
        pageTitle: '酒店设计',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        description: `华美全程把控从概念设计到施工图落地的每个环节，在确保设计美感的同时兼顾功能性与运营效率。许多项目常因设计方与酒管公司标准脱节、图纸细节缺失导致返工，或因造价失控影响投资回报。华美凭借丰富的品牌标准库和造价数据库，帮助业主实现既符合品牌调性又具有商业价值的设计成果。`,
        icons: [
            {
                name: '设计管理',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/3.设计管理.pdf'),
                path: "四库赋能-酒店建设/设计管理/成功案例"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店建设/设计管理/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/设计管理/数据赋能'),
                path: "四库赋能-酒店建设/设计管理/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/设计管理/全球案例/全球案例（设计管理）.xlsx'),
                path: "四库赋能-酒店建设/设计管理/案例库"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/设计管理/预警问题/预警问题（设计管理）.xlsx'),
                path: "四库赋能-酒店建设/设计管理/预警问题"
            },
        ]
    }]
}